// extracted by mini-css-extract-plugin
export default {"modal":"mMnVIngJtA6SFAF3VpPJ"};